import { render, staticRenderFns } from "./DigitalIdUserModal.vue?vue&type=template&id=72010ccd&"
import script from "./DigitalIdUserModal.vue?vue&type=script&lang=js&"
export * from "./DigitalIdUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports